import {combineReducers} from 'redux'
import user from './user'
import form from './form'
import forms from './forms'
import selectedPage from './selectedPage'
import modalReducer from './modal'
//import surveyState from './surveyState'

export default combineReducers({
    user,
    form,
    forms,
    selectedPage,
    modalReducer
})


// WEBPACK FOOTER //
// ./src/reducers/index.js